import { FileId } from "@sp-crm/core";

export interface UploadedFile {
    id: string;
    name: string;
    size: number;
    status: "uploading" | "completed" | "error";
    progress: number;
    error?: string;
    serverId?: FileId;
}

export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 KB";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    if (i === 0) {
        return "1 KB";
    }

    const size = bytes / Math.pow(k, i);
    if (size < 10) {
        return Math.round(size * 10) / 10 + " " + sizes[i];
    }
    return Math.round(size) + " " + sizes[i];
};
